import React from 'react';
import { FaUserSlash } from 'react-icons/fa';
import './BlockedPage.css';

const BlockedPage = () => {
  // Функция для закрытия приложения Telegram Web App
  const closeApp = () => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    }
  };

  return (
    <div className="blocked-page">
      <div className="blocked-icon">
        <FaUserSlash />
      </div>
      <h1 className="blocked-title">Вы заблокированы в этом боте навсегда</h1>
      <p className="blocked-message">
        К сожалению, доступ к контенту для вас ограничен. 
        Если вы считаете, что произошла ошибка, пожалуйста, свяжитесь с администратором.
      </p>
      {window.Telegram?.WebApp && (
        <button 
          onClick={closeApp}
          style={{
            padding: '10px 20px',
            background: 'var(--tg-theme-button-color, #50a8eb)',
            color: 'var(--tg-theme-button-text-color, #ffffff)',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Закрыть
        </button>
      )}
    </div>
  );
};

export default BlockedPage;
